(ns common.schema.associations
  (:require
   [common.roles :as roles]
   [potpuri.core :as potpuri]))

(def one-way-schemas
  {:entity.type/company
   {:entity.type/oppo
    {:association.type/referrer          {:translations            {:en "Referrer"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              1.0}
     :association.type/legal-advisor     {:translations            {:en "Legal advisor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              2.0}
     :association.type/financial-advisor {:translations            {:en "Financial advisor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              3.0}
     :association.type/advisor           {:translations            {:en "Advisor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              4.0}
     :association.type/mandate-firm      {:translations            {:en "Mandate firm"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              5.0}
     :association.type/introducer-firm   {:translations            {:en "Introducer firm"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              6.0}
     :association.type/buy-side-advisor  {:translations            {:en "Buy-side advisor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              7.0}
     :association.type/acquisition-deal  {:translations            {:en "Acquisition deal"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              8.0}
     :association.type/in-licensing      {:translations            {:en "In-licensing"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              9.0}
     :association.type/out-licensing     {:translations            {:en "Out-licensing"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              10.0}
     :association.type/joint-venture     {:translations            {:en "Joint venture"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              11.0}
     :association.type/other             {:translations            {:en "Other"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              12.0}}
    :entity.type/person
    {:association.type/contact-person               {:translations            {:en "Contact person"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              1.0}
     :association.type/executive                    {:translations            {:en "Executive"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              2.0}
     :association.type/founder                      {:translations            {:en "Founder"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              3.0}
     :association.type/chairman                     {:translations            {:en "Chairman"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              4.0}
     :association.type/board-member                 {:translations            {:en "Board member"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              5.0}
     :association.type/advisor                      {:translations            {:en "Advisor"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              6.0}
     :association.type/lead-investor-contact-person {:translations            {:en "Lead investor contact"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              7.0}
     :association.type/entrepreneur                 {:association/cardinality :cardinality/many
                                                     :translations            {:en "Entrepreneur"}
                                                     :common/ord              8.0}
     :association.type/employee                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Employee"}
                                                     :common/ord              9.0}
     :association.type/ceo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CEO"}
                                                     :common/ord              10.0}
     :association.type/cto                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CTO"}
                                                     :common/ord              11.0}
     :association.type/cfo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CFO"}
                                                     :common/ord              12.0}
     :association.type/coo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "COO"}
                                                     :common/ord              13.0}
     :association.type/cbo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CBO"}
                                                     :common/ord              14.0}
     :association.type/cso                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CSO"}
                                                     :common/ord              15.0}
     :association.type/cmo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CMO"}
                                                     :common/ord              16.0}
     :association.type/associate                    {:association/cardinality :cardinality/many
                                                     :translations            {:en "Associate"}
                                                     :common/ord              17.0}
     :association.type/analyst                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Analyst"}
                                                     :common/ord              18.0}
     :association.type/principal                    {:association/cardinality :cardinality/many
                                                     :translations            {:en "Principal"}
                                                     :common/ord              19.0}
     :association.type/investment-director          {:association/cardinality :cardinality/many
                                                     :translations            {:en "Investment director"}
                                                     :common/ord              20.0}
     :association.type/advisor-consultant           {:association/cardinality :cardinality/many
                                                     :translations            {:en "Advisor/Consultant"}
                                                     :common/ord              21.0}
     :association.type/expert-kol-scientist         {:association/cardinality :cardinality/many
                                                     :translations            {:en "Expert/KOL/Scientist"}
                                                     :common/ord              22.0}

     :association.type/co-founder                   {:association/cardinality :cardinality/many
                                                     :translations            {:en "Co-founder"}
                                                     :common/ord              23.0}
     :association.type/director                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Director"}
                                                     :common/ord              24.0}
     :association.type/managing-director            {:association/cardinality :cardinality/many
                                                     :translations            {:en "Managing director"}
                                                     :common/ord              25.0}
     :association.type/observer                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Observer"}
                                                     :common/ord              26.0}
     :association.type/initial-contact-person       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Initial contact person"}
                                                     :common/ord              27.0}
     :association.type/primary-contact-person       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Primary contact person"}
                                                     :common/ord              28.0}
     :association.type/secondary-contact-person     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Secondary contact person"}
                                                     :common/ord              29.0}
     :association.type/assistant-or-secretary       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Assistant/Secretary"}
                                                     :common/ord              30.0}
     :association.type/chairman-of-the-board        {:association/cardinality :cardinality/many
                                                     :translations            {:en "Chairman of the board"}
                                                     :common/ord              31.0}
     :association.type/board-observer               {:association/cardinality :cardinality/many
                                                     :translations            {:en "Board observer"}
                                                     :common/ord              32.0}
     :association.type/managing-partner             {:association/cardinality :cardinality/many
                                                     :translations            {:en "Managing partner"}
                                                     :common/ord              33.0}
     :association.type/partner                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Partner"}
                                                     :common/ord              34.0}
     :association.type/esg-specialist               {:association/cardinality :cardinality/many
                                                     :translations            {:en "ESG specialist"}
                                                     :common/ord              35.0}
     :association.type/relevant-network             {:translations            {:en "Relevant network"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              36.0}

     :association.type/other                        {:translations            {:en "Other"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              37.0}}

    :entity.type/holding
    {:association.type/competitor         {:translations            {:en "Competitor"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              1.0}
     :association.type/acquisition-target {:translations            {:en "Acquisition target"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              2.0}
     :association.type/potential-buyer    {:translations            {:en "Potential buyer"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              3.0}
     :association.type/holding            {:translations            {:en "Holding"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              4.0}

     ; Main and sub holding will be filtered in frontend to visible only to Liechtenstein Group for now
     :association.type/main-holding       {:translations            {:en "Main holding"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              5.0}
     :association.type/sub-holdings       {:translations            {:en "Sub holdings"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              6.0}
     :association.type/other              {:translations            {:en "Other"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              7.0}}

    :entity.type/company
    {:association.type/competitor         {:translations            {:en "Competitor"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              1.0}
     :association.type/similar            {:translations            {:en "Similar"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              2.0}
     :association.type/shareholding       {:translations            {:en "Shareholding"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              3.0}
     :association.type/portfolio-company  {:translations            {:en "Portfolio company"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              4.0}
     :association.type/strategic-partner  {:translations            {:en "Strategic partner"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              5.0}
     :association.type/ownership          {:translations            {:en "Ownership"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              6.0}
     :association.type/m-a-opportunity    {:translations            {:en "M&A opportunity"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              7.0}
     :association.type/potential-buyer    {:translations            {:en "Potential buyer"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              8.0}
     :association.type/acquisition-target {:translations            {:en "Acquisition target"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              9.0}
     :association.type/other              {:translations            {:en "Other"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              10.0}}

    :entity.type/fund
    {:association.type/auditing-firm                    {:translations            {:en "Auditing firm"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              1.0}
     :association.type/fund-administering-firm          {:translations            {:en "Fund administering firm"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              2.0}
     :association.type/legal-counsel                    {:translations            {:en "Legal counsel"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              3.0}
     :association.type/primary-bank                     {:translations            {:en "Primary bank"}
                                                         :association/cardinality :cardinality/one
                                                         :common/ord              4.0}
     :association.type/fund-leverage-provider           {:translations            {:en "Fund leverage provider"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              5.0}
     :association.type/fund-depositary                  {:translations            {:en "Fund depositary"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              6.0}
     :association.type/independent-valuation-firm       {:translations            {:en "Independent valuation firm"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              7.0}
     :association.type/independent-risk-management-firm {:translations
                                                         {:en "Independent risk management firm"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              8.0}
     :association.type/fund-custodian                   {:translations            {:en "Fund custodian"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              8.0}
     :association.type/other-advising-firm              {:translations            {:en "Other advising firm"}
                                                         :association/cardinality :cardinality/many
                                                         :common/ord              9.0}}}

   :entity.type/oppo
   {:entity.type/person
    {:association.type/contact-person               {:translations            {:en "Contact person"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              1.0}
     :association.type/referrer-person              {:translations            {:en "Deal referrer"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              2.0}
     :association.type/buy-side-advisor             {:translations            {:en "Buy-side advisor"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              3.0}
     :association.type/sell-side-advisor            {:translations            {:en "Sell-side advisor"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              4.0}
     :association.type/group-contact-person         {:translations            {:en "Group contact person"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              5.0}
     :association.type/subject-matter-expert        {:translations            {:en "Subject matter expert"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              6.0}
     :association.type/bu-responsible               {:translations            {:en "BU responsible"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              7.0}
     :association.type/lead-investor-contact-person {:translations            {:en "Lead investor contact"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              8.0}
     :association.type/entrepreneur                 {:association/cardinality :cardinality/many
                                                     :translations            {:en "Entrepreneur"}
                                                     :common/ord              9.0}
     :association.type/initial-contact-person       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Initial contact person"}
                                                     :common/ord              10.0}
     :association.type/primary-contact-person       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Primary contact person"}
                                                     :common/ord              11.0}
     :association.type/secondary-contact-person     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Secondary contact person"}
                                                     :common/ord              12.0}
     :association.type/assistant-or-secretary       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Assistant/Secretary"}
                                                     :common/ord              13.0}
     :association.type/other                        {:translations            {:en "Other"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              14.0}
     :association.type/co-investor                  {:association/cardinality :cardinality/many
                                                     :translations            {:en "Co-Investor"}
                                                     :common/ord              15.0}}

    :entity.type/holding
    {:association.type/closed              {:translations            {:en "Closed"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              1.0}
     :association.type/follow-on-candidate {:translations            {:en "Follow on candidate"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              2.0}
     :association.type/follow-on-closed    {:translations            {:en "Follow on closed"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              3.0}
     :association.type/rejected-deal       {:translations            {:en "Rejected deal"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              3.0}
     :association.type/acquisition-deal    {:translations            {:en "Acquisition deal"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              4.0}
     :association.type/other               {:translations            {:en "Other"}
                                            :association/cardinality :cardinality/many
                                            :common/ord              5.0}}

    :entity.type/fof-asset
    {:association.type/existing-investor {:translations            {:en "Existing investor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              1.0}
     :association.type/co-investor       {:translations            {:en "Co-investor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              2.0}
     :association.type/lead-investor     {:translations            {:en "Lead investor"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              3.0}
     :association.type/other             {:translations            {:en "Other"}
                                          :association/cardinality :cardinality/many
                                          :common/ord              4.0}}
    :entity.type/oppo
    {:association.type/mutually-exclusive {:translations            {:en "Mutually exclusive"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              1.0}
     :association.type/buy-and-build      {:translations            {:en "Buy and build"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              2.0}
     :association.type/other              {:translations            {:en "Other"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              3.0}}
    :entity.type/investor
    {:association.type/possible-co-investor   {:translations            {:en "Possible co-investor"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              1.0}
     :association.type/possible-lead-investor {:translations            {:en "Possible lead investor"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              2.0}
     :association.type/existing-investor      {:translations            {:en "Existing investor"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              3.0}}}
   :entity.type/fund-commitment
   {:entity.type/person
    {:association.type/primary-contact                     {:translations            {:en "Primary contact"}
                                                            :association/cardinality :cardinality/one
                                                            :common/ord              1.0}
     :association.type/reporting-contact                   {:translations            {:en "Fund reporting contact"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              2.0}
     :association.type/entrepreneur                        {:association/cardinality :cardinality/many
                                                            :translations            {:en "Entrepreneur"}
                                                            :common/ord              3.0}
     :association.type/adb-member                          {:translations            {:en "ADB member"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              4.0}
     :association.type/cc-contact-to-adb-member            {:translations            {:en "cc. contact to ADB member"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              5.0}
     :association.type/back-office-contact                 {:translations            {:en "Back office contact"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              6.0}
     :association.type/lp-representative                   {:translations            {:en "LP representative"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              7.0}
     :association.type/cc-contact-to-lp-representative     {:translations
                                                            {:en "cc. contact to LP representative"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              8.0}
     :association.type/lp-meeting-correspondence           {:translations            {:en "LP meeting correspondence"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              9.0}
     :association.type/draw-down-capital-call-correspondence
     {:translations            {:en "Drawdown / Capital call correspondence"}
      :association/cardinality :cardinality/many
      :common/ord              10.0}
     :association.type/distribution-notices-correspondence {:translations
                                                            {:en
                                                             "Distribution notices correspondence"}
                                                            :association/cardinality
                                                            :cardinality/many
                                                            :common/ord 11.0}
     :association.type/financial-reports-correspondence    {:translations
                                                            {:en "Financial reports correspondence"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              12.0}
     :association.type/legal-correspondence                {:translations            {:en "Legal correspondence"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              13.0}
     :association.type/tax-correspondence                  {:translations            {:en "Tax correspondence"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              14.0}
     :association.type/other                               {:translations            {:en "Other"}
                                                            :association/cardinality :cardinality/many
                                                            :common/ord              15.0}}
    :entity.type/fund-commitment
    {:association.type/co-investment      {:translations            {:en "Co-investment"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              1.0}
     :association.type/mutually-exclusive {:translations            {:en "Mutually exclusive"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              2.0}
     :association.type/other              {:translations            {:en "Other"}
                                           :association/cardinality :cardinality/many
                                           :common/ord              3.0}}}

   :entity.type/holding
   {:entity.type/person
    {:association.type/contact-person               {:translations            {:en "Contact person"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              1.0}
     :association.type/relevant-network             {:translations            {:en "Relevant network"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              2.0}
     :association.type/entrepreneur                 {:association/cardinality :cardinality/many
                                                     :translations            {:en "Entrepreneur"}
                                                     :common/ord              3.0}
     :association.type/ceo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CEO"}
                                                     :common/ord              4.0}
     :association.type/cfo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CFO"}
                                                     :common/ord              5.0}
     :association.type/coo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "COO"}
                                                     :common/ord              6.0}
     :association.type/cto                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CTO"}
                                                     :common/ord              7.0}

     :association.type/cbo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CBO"}
                                                     :common/ord              8.0}
     :association.type/cso                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CSO"}
                                                     :common/ord              9.0}
     :association.type/cmo                          {:association/cardinality :cardinality/many
                                                     :translations            {:en "CMO"}
                                                     :common/ord              10.0}
     :association.type/associate                    {:association/cardinality :cardinality/many
                                                     :translations            {:en "Associate"}
                                                     :common/ord              11.0}
     :association.type/analyst                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Analyst"}
                                                     :common/ord              12.0}
     :association.type/principal                    {:association/cardinality :cardinality/many
                                                     :translations            {:en "Principal"}
                                                     :common/ord              13.0}
     :association.type/investment-director          {:association/cardinality :cardinality/many
                                                     :translations            {:en "Investment director"}
                                                     :common/ord              14.0}
     :association.type/advisor-consultant           {:association/cardinality :cardinality/many
                                                     :translations            {:en "Advisor/Consultant"}
                                                     :common/ord              15.0}
     :association.type/expert-kol-scientist         {:association/cardinality :cardinality/many
                                                     :translations            {:en "Expert/KOL/Scientist"}
                                                     :common/ord              16.0}

     :association.type/board-member                 {:association/cardinality :cardinality/many
                                                     :translations            {:en "Board member"}
                                                     :common/ord              17.0}

     :association.type/chairman                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Chairman"}
                                                     :common/ord              18.0}

     :association.type/advisor                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Advisor"}
                                                     :common/ord              19.0}

     :association.type/founder                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Founder"}
                                                     :common/ord              20.0}

     :association.type/co-founder                   {:association/cardinality :cardinality/many
                                                     :translations            {:en "Co-founder"}
                                                     :common/ord              21.0}

     :association.type/director                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Director"}
                                                     :common/ord              22.0}

     :association.type/partner                      {:association/cardinality :cardinality/many
                                                     :translations            {:en "Partner"}
                                                     :common/ord              23.0}

     :association.type/employee                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Employee"}
                                                     :common/ord              24.0}

     :association.type/observer                     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Observer"}
                                                     :common/ord              25.0}

     :association.type/assistant-or-secretary       {:association/cardinality :cardinality/many
                                                     :translations            {:en "Assistant/Secretary"}
                                                     :common/ord              26.0}

     :association.type/chairman-of-the-board        {:association/cardinality :cardinality/many
                                                     :translations            {:en "Chairman of the board"}
                                                     :common/ord              27.0}
     :association.type/board-observer               {:association/cardinality :cardinality/many
                                                     :translations            {:en "Board observer"}
                                                     :common/ord              28.0}
     :association.type/esg-specialist               {:association/cardinality :cardinality/many
                                                     :translations            {:en "ESG specialist"}
                                                     :common/ord              29.0}

     :association.type/lead-investor-contact-person {:translations            {:en "Lead investor contact"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              30.0}
     :association.type/secondary-contact-person     {:association/cardinality :cardinality/many
                                                     :translations            {:en "Secondary contact person"}
                                                     :common/ord              31.0}

     :association.type/other                        {:translations            {:en "Other"}
                                                     :association/cardinality :cardinality/many
                                                     :common/ord              36.0}}

    :entity.type/fundraising-opportunity
    {:association.type/other {:translations            {:en "Other"}
                              :association/cardinality :cardinality/many
                              :common/ord              1.0}}
    :entity.type/investor
    {:association.type/co-investor   {:translations            {:en "Co-investor"}
                                      :association/cardinality :cardinality/many
                                      :common/ord              1.0}
     :association.type/lead-investor {:translations            {:en "Lead investor"}
                                      :association/cardinality :cardinality/many
                                      :common/ord              2.0}
     :association.type/other         {:translations            {:en "Other"}
                                      :association/cardinality :cardinality/many
                                      :common/ord              3.0}}
    :entity.type/real-estate
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}
    :entity.type/fof-asset
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}
    :entity.type/other-asset
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}}

   :entity.type/fund
   {:entity.type/person
    {:association.type/key-man                           {:translations            {:en "Key man"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              1.0}
     :association.type/investor-relations-contact-person {:translations
                                                          {:en "Investor relations contact"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              2.0}
     :association.type/contact-person                    {:translations            {:en "Contact person"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              3.0}
     :association.type/auditor                           {:translations            {:en "Auditor"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              4.0}
     :association.type/fund-administrator                {:translations            {:en "Fund administrator"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              5.0}
     :association.type/legal-counselor                   {:translations            {:en "Legal counselor"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              6.0}
     :association.type/primary-bank-contact-person       {:translations            {:en
                                                                                    "Primary bank contact person"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              7.0}
     :association.type/fund-depositary-contact-person    {:translations
                                                          {:en "Fund depositary contact person"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              8.0}
     :association.type/fund-custodian-contact-person     {:translations
                                                          {:en "Fund custodian contact person"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              9.0}
     :association.type/independent-valuation-expert      {:translations            {:en
                                                                                    "Independent valuation expert"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              10.0}
     :association.type/independent-risk-manager          {:translations            {:en "Independent risk manager"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              11.0}
     :association.type/investment-committee-member       {:translations            {:en
                                                                                    "Investment committee member"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              12.0}
     :association.type/lpac-committee-member             {:translations            {:en "LPAC committee member"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              13.0}
     :association.type/other-advisor                     {:translations            {:en "Other advisor"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              14.0}
     :association.type/entrepreneur                      {:association/cardinality :cardinality/many
                                                          :translations            {:en "Entrepreneur"}
                                                          :common/ord              15.0}
     :association.type/external-report-access            {:association/cardinality :cardinality/many
                                                          :translations            {:en "External report access"}
                                                          :common/ord              16.0}
     :association.type/other                             {:translations            {:en "Other"}
                                                          :association/cardinality :cardinality/many
                                                          :common/ord              17.0}}}
   :entity.type/investor
   {:entity.type/person
    {:association.type/gatekeeper               {:translations            {:en "Gatekeeper"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              1.0}
     :association.type/decision-maker           {:translations            {:en "Decision maker"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              2.0}
     :association.type/contact-person           {:translations            {:en "Contact person"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              3.0}
     :association.type/cws-contact              {:translations            {:en "CWS contact"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              4.0}
     :association.type/entrepreneur             {:association/cardinality :cardinality/many
                                                 :translations            {:en "Entrepreneur"}
                                                 :common/ord              5.0}
     :association.type/initial-contact-person   {:association/cardinality :cardinality/many
                                                 :translations            {:en "Initial contact person"}
                                                 :common/ord              6.0}
     :association.type/primary-contact-person   {:association/cardinality :cardinality/many
                                                 :translations            {:en "Primary contact person"}
                                                 :common/ord              7.0}
     :association.type/secondary-contact-person {:association/cardinality :cardinality/many
                                                 :translations            {:en "Secondary contact person"}
                                                 :common/ord              8.0}
     :association.type/assistant-or-secretary   {:association/cardinality :cardinality/many
                                                 :translations            {:en "Assistant/Secretary"}
                                                 :common/ord              9.0}
     :association.type/chairman-of-the-board    {:association/cardinality :cardinality/many
                                                 :translations            {:en "Chairman of the board"}
                                                 :common/ord              10.0}
     :association.type/managing-partner         {:association/cardinality :cardinality/many
                                                 :translations            {:en "Managing partner"}
                                                 :common/ord              11.0}
     :association.type/partner                  {:association/cardinality :cardinality/many
                                                 :translations            {:en "Partner"}
                                                 :common/ord              12.0}
     :association.type/esg-specialist           {:association/cardinality :cardinality/many
                                                 :translations            {:en "ESG specialist"}
                                                 :common/ord              13.0}
     :association.type/advisor-consultant       {:association/cardinality :cardinality/many
                                                 :translations            {:en "Advisor/Consultant"}
                                                 :common/ord              14.0}
     :association.type/associate                {:association/cardinality :cardinality/many
                                                 :translations            {:en "Associate"}
                                                 :common/ord              15.0}
     :association.type/board-member             {:translations            {:en "Board member"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              16.0}
     :association.type/cfo                      {:association/cardinality :cardinality/many
                                                 :translations            {:en "CFO"}
                                                 :common/ord              17.0}
     :association.type/director                 {:association/cardinality :cardinality/many
                                                 :translations            {:en "Director"}
                                                 :common/ord              18.0}
     :association.type/relevant-network         {:translations            {:en "Relevant network"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              19.0}

     :association.type/other                    {:translations            {:en "Other"}
                                                 :association/cardinality :cardinality/many
                                                 :common/ord              20.0}}
    :entity.type/investor
    {:association.type/investment-vehicle    {:translations                 {:en "Investment vehicle"}
                                              :association/uni-directional? true
                                              :association/source-direction
                                              :association.type/investment-vehicle
                                              :association/target-direction
                                              :association.type/investment-vehicle-of
                                              :association/cardinality      :cardinality/many
                                              :common/ord                   1.0}
     :association.type/investment-vehicle-of {:translations                 {:en "Investment vehicle of"}
                                              :association/uni-directional? true
                                              :association/source-direction
                                              :association.type/investment-vehicle-of
                                              :association/target-direction
                                              :association.type/investment-vehicle
                                              :association/cardinality      :cardinality/many
                                              :common/ord                   1.0}
     :association.type/co-investor           {:translations            {:en "Co-investor"}
                                              :association/cardinality :cardinality/many
                                              :common/ord              2.0}
     :association.type/lead-investor         {:translations            {:en "Lead investor"}
                                              :association/cardinality :cardinality/one
                                              :common/ord              3.0}}}
   :entity.type/fundraising-opportunity
   {:entity.type/person
    {:association.type/primary-contact {:translations            {:en "Primary contact"}
                                        :association/cardinality :cardinality/one
                                        :common/ord              0}
     :association.type/contact-person  {:translations            {:en "Contact person"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              1.0}
     :association.type/decision-maker  {:translations            {:en "Decision maker"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              2.0}
     :association.type/gatekeeper      {:translations            {:en "Gatekeeper"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              3.0}
     :association.type/advisor         {:translations            {:en "Advisor"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              4.0}
     :association.type/placement-agent {:translations            {:en "Placement agent"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              5.0}
     :association.type/entrepreneur    {:association/cardinality :cardinality/many
                                        :translations            {:en "Entrepreneur"}
                                        :common/ord              6.0}
     :association.type/outdated        {:association/cardinality :cardinality/many
                                        :translations            {:en "Outdated"}
                                        :common/ord              7.0}
     :association.type/other           {:translations            {:en "Other"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              8.0}}
    :entity.type/fundraising-opportunity
    {:association.type/potential-coinvestment {:translations            {:en "Potential co-investment"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              1.0}
     :association.type/mutually-exclusive     {:translations            {:en "Mutually exclusive"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              2.0}
     :association.type/other                  {:translations            {:en "Other"}
                                               :association/cardinality :cardinality/many
                                               :common/ord              3.0}}}
   :entity.type/sales-opportunity
   {:entity.type/person
    {:association.type/primary-contact {:translations            {:en "Primary contact"}
                                        :association/cardinality :cardinality/one
                                        :common/ord              0}
     :association.type/contact-person  {:translations            {:en "Contact person"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              1.0}
     :association.type/decision-maker  {:translations            {:en "Decision maker"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              2.0}
     :association.type/advisor         {:translations            {:en "Advisor"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              3.0}
     :association.type/entrepreneur    {:association/cardinality :cardinality/many
                                        :translations            {:en "Entrepreneur"}
                                        :common/ord              4.0}
     :association.type/other           {:translations            {:en "Other"}
                                        :association/cardinality :cardinality/many
                                        :common/ord              5.0}}}
   :entity.type/exit-opportunity
   {:entity.type/person
    {:association.type/buy-side
     {:translations            {:en "Buy-side"}
      :association/cardinality :cardinality/many
      :common/ord              0.0}
     :association.type/sell-side
     {:translations            {:en "Sell-side"}
      :association/cardinality :cardinality/many
      :common/ord              1.0}
     :association.type/other
     {:translations            {:en "Other"}
      :association/cardinality :cardinality/many
      :common/ord              2.0}}
    :entity.type/investor
    {:association.type/co-investor
     {:translations            {:en "Co-investor"}
      :association/cardinality :cardinality/many
      :common/ord              0.0}
     :association.type/other
     {:translations            {:en "Other"}
      :association/cardinality :cardinality/many
      :common/ord              1.0}}
    :entity.type/exit-opportunity
    {:association.type/mutually-exclusive
     {:translations            {:en "Mutually exclusive"}
      :association/cardinality :cardinality/many
      :common/ord              0.0}
     :association.type/both-or-neither
     {:translations            {:en "Both or neither"}
      :association/cardinality :cardinality/many
      :common/ord              1.0}
     :association.type/other
     {:translations            {:en "Other"}
      :association/cardinality :cardinality/many
      :common/ord              2.0}}}
   :entity.type/person
   {:entity.type/person
    {:association.type/referral     {:association/cardinality :cardinality/many
                                     :translations            {:en "Referral"}
                                     :common/ord              1.0}
     :association.type/colleague    {:association/cardinality :cardinality/many
                                     :translations            {:en "Colleague"}
                                     :common/ord              2.0}
     :association.type/spouse       {:association/cardinality :cardinality/one
                                     :translations            {:en "Spouse"}
                                     :common/ord              3.0}
     :association.type/family       {:association/cardinality :cardinality/many
                                     :translations            {:en "Family"}
                                     :common/ord              4.0}
     :association.type/friend       {:association/cardinality :cardinality/many
                                     :translations            {:en "Friend"}
                                     :common/ord              5.0}
     :association.type/enemy        {:association/cardinality :cardinality/many
                                     :translations            {:en "Enemy"}
                                     :common/ord              6.0}
     :association.type/entrepreneur {:association/cardinality :cardinality/many
                                     :translations            {:en "Entrepreneur"}
                                     :common/ord              7.0}
     :association.type/other        {:association/cardinality :cardinality/many
                                     :translations            {:en "Other"}
                                     :common/ord              8.0}}
    :entity.type/fof-asset
    {:association.type/contact-person {:association/cardinality :cardinality/many
                                       :translations            {:en "Contact person"}
                                       :common/ord              1.0}
     :association.type/other          {:association/cardinality :cardinality/many
                                       :translations            {:en "Other"}
                                       :common/ord              2.0}}
    :entity.type/other-asset
    {:association.type/contact-person {:association/cardinality :cardinality/many
                                       :translations            {:en "Contact person"}
                                       :common/ord              1.0}
     :association.type/other          {:association/cardinality :cardinality/many
                                       :translations            {:en "Other"}
                                       :common/ord              2.0}}
    :entity.type/real-estate
    {:association.type/contact-person {:association/cardinality :cardinality/many
                                       :translations            {:en "Contact person"}
                                       :common/ord              1.0}
     :association.type/other          {:association/cardinality :cardinality/many
                                       :translations            {:en "Other"}
                                       :common/ord              2.0}}}
   :entity.type/real-estate
   {:entity.type/real-estate
    {:association.type/other {:association/cardinality :cardinality/many
                              :translations            {:en "Other"}
                              :common/ord              1.0}}
    :entity.type/fof-asset
    {:association.type/other {:association/cardinality :cardinality/many
                              :translations            {:en "Other"}
                              :common/ord              1.0}}
    :entity.type/other-asset
    {:association.type/other {:association/cardinality :cardinality/many
                              :translations            {:en "Other"}
                              :common/ord              1.0}}
    :entity.type/person
    {:association.type/entrepreneur {:association/cardinality :cardinality/many
                                     :translations            {:en "Entrepreneur"}
                                     :common/ord              1.0}
     :association.type/other        {:association/cardinality :cardinality/many
                                     :translations            {:en "Other"}
                                     :common/ord              2.0}}}
   :entity.type/fof-asset
   {:entity.type/fof-asset
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}
    :entity.type/company
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}
    :entity.type/person
    {:association.type/entrepreneur {:association/cardinality :cardinality/many
                                     :translations            {:en "Entrepreneur"}
                                     :common/ord              1.0}
     :association.type/other        {:association/cardinality :cardinality/many
                                     :translations            {:en "Other"}
                                     :common/ord              2.0}}
    :entity.type/real-estate
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}
    :entity.type/other-asset
    {:association.type/holding {:association/cardinality :cardinality/many
                                :translations            {:en "Holding"}
                                :common/ord              1.0}
     :association.type/other   {:association/cardinality :cardinality/many
                                :translations            {:en "Other"}
                                :common/ord              2.0}}}
   :entity.type/other-asset
   {:entity.type/other-asset
    {:association.type/other {:association/cardinality :cardinality/many
                              :translations            {:en "Other"}
                              :common/ord              1.0}}
    :entity.type/person
    {:association.type/entrepreneur {:association/cardinality :cardinality/many
                                     :translations            {:en "Entrepreneur"}
                                     :common/ord              1.0}
     :association.type/other        {:association/cardinality :cardinality/many
                                     :translations            {:en "Other"}
                                     :common/ord              2.0}}}
   :entity.type/sale-agreement
   {:entity.type/person
    {:association.type/contact-person {:association/cardinality :cardinality/many
                                       :translations            {:en "Contact person"}
                                       :common/ord              1.0}
     :association.type/entrepreneur   {:association/cardinality :cardinality/many
                                       :translations            {:en "Entrepreneur"}
                                       :common/ord              2.0}
     :association.type/other          {:association/cardinality :cardinality/many
                                       :translations            {:en "Other"}
                                       :common/ord              3.0}}}})

(def schema
  (->> one-way-schemas
       (map (fn [[from-entity-type to-types-map]]
              [from-entity-type
               (potpuri/deep-merge
                to-types-map
                (->> one-way-schemas
                     (keep (fn [[et to-types]]
                             (when-let [reverse-references (get to-types from-entity-type)]
                               [et reverse-references])))
                     (into {})))]))
       (into {})))

(defn write-access?
  [_association _account role _entity & [_logger]]
;; TODO: access to modify associations per association and role type
  (isa? roles/role-hierarchy role :role/user))

(defn add-access?
  [_entity _association-type _account role & [_logger]]
  ;; TODO: access to modify associations per association and role type
  (isa? roles/role-hierarchy role :role/user))

(defn other-entity-id
  [association entity-id]
  (let [source (:entity-association/source-entity association)
        target (:entity-association/target-entity association)
        source-id (or (:db/id source) source)
        target-id (or (:db/id target) target)]
    (cond (= source-id entity-id)
          target-id
          (= target-id entity-id)
          source-id)))

(def association-hierarchy
  (->> one-way-schemas
       (mapcat (fn [[et targets]]
                 (cons et (keys targets))))
       (set)
       (sort-by name)
       (vec)))

(defn resolve-source-and-target
  "Returns
   {:source-entity entity
    :target-entity entity
    :error <possible error message if the order could not be resolved>
    }"
  [source-entity-candidate target-entity-candidate]
  (let [source-candidate-type (:entity/type source-entity-candidate)
        target-candidate-type (:entity/type target-entity-candidate)
        source-candidate-hierarchy-idx (.indexOf association-hierarchy source-candidate-type)
        target-candidate-hierarchy-idx (.indexOf association-hierarchy target-candidate-type)]
    (cond
      (or (not source-candidate-type)
          (not target-candidate-type))
      {:error "Entity type(s) missing"}

      (or (= source-candidate-hierarchy-idx -1)
          (= target-candidate-hierarchy-idx -1))
      {:error "Could not resolve hierarchy index or indices"}

      :else
      (if (< target-candidate-hierarchy-idx source-candidate-hierarchy-idx)
        {:source-entity target-entity-candidate
         :target-entity source-entity-candidate}
        {:source-entity source-entity-candidate
         :target-entity target-entity-candidate}))))
